import React, { FC, useEffect, useRef, useState } from 'react';
import sprite from 'assets/imgs/torch-ring/sprite_sheet-text-new.png';
import './index.less';
import HomeLoading from '../HomeLoading';
import axios from 'axios';
const TorchRing: FC<{
  onLoad?: () => void;
}> = ({ onLoad }) => {
  const spriteRef = useRef<HTMLDivElement>(null);
  const [imageSrc, setImageSrc] = useState('');
  const [loading, setLoading] = useState(true); // 0-未加载 1-加载中 2-加载完成
  const [progress, setProgress] = useState(0);

  const loadImage = async (imageUrl) => {
    try {
      // 使用 Axios 获取图片并监听进度
      const response = await axios.get(imageUrl, {
        responseType: 'blob',
        onDownloadProgress: (progressEvent) => {
          if (progressEvent.lengthComputable) {
            const percent = (progressEvent.loaded / progressEvent.total) * 100;
            setProgress(percent);
          }
        },
      });

      // 创建图片的 Blob URL 并设置到状态中
      const imgURL = URL.createObjectURL(response.data);
      setImageSrc(imgURL);
      setLoading(false);
    } catch (error) {
      console.error('图片加载失败', error);
    }
  };

  useEffect(() => {
    // loadImage('assets/imgs/torch-ring/css_sprites-final.png');
    loadImage(sprite);
  }, []);

  return (
    <div className="torchRing" ref={spriteRef}>
      <div
        className="sprite"
        style={{
          backgroundImage: loading ? 'none' : `url(${imageSrc})`,
          opacity: !loading ? 1 : 0,
        }}
      />

      <HomeLoading
        progress={progress}
        style={{
          opacity: loading ? 1 : 0,
        }}
      />
    </div>
  );
};

export default TorchRing;
